import React from "react";
import { Layout, Typography, Card, Row, Col, Button } from "antd";
import { CodeOutlined, ExperimentOutlined, CloudOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const aiDeveloperFeatures = [
    {
        title: "AI-Powered Code Assist",
        description: "Enhance your development workflow with intelligent code suggestions and automation.",
        icon: <CodeOutlined style={{ fontSize: "48px", color: "#1890ff" }} />,
    },
    {
        title: "Machine Learning Models",
        description: "Access pre-trained AI models for image recognition, NLP, and predictive analytics.",
        icon: <ExperimentOutlined style={{ fontSize: "48px", color: "#52c41a" }} />,
    },
    {
        title: "Cloud AI Integration",
        description: "Seamlessly deploy and scale AI applications with cloud-based solutions.",
        icon: <CloudOutlined style={{ fontSize: "48px", color: "#faad14" }} />,
    },
];

const AIDevelopers = () => {
    return (
        <Layout>
            <Content style={{ padding: "50px" }}>
                <Title level={3} style={{ fontSize: "24px" }}>AI for Developers</Title> {/* Reduced from level 2 (32px) to level 3 (24px) */}
                <Paragraph>Empower your development projects with cutting-edge AI tools, APIs, and frameworks.</Paragraph>

                <Row gutter={[16, 16]}>
                    {aiDeveloperFeatures.map((feature, index) => (
                        <Col xs={24} sm={12} md={8} key={index}>
                            <Card hoverable>
                                {feature.icon}
                                <Title level={4}>{feature.title}</Title>
                                <Paragraph>{feature.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Button 
                    type="primary" 
                    size="large" 
                    href="/signin" 
                    style={{ marginTop: "20px" }}
                >
                    Get Started with AI
                </Button>
            </Content>
        </Layout>
    );
};

export default AIDevelopers;